import { HiOutlineXMark } from "react-icons/hi2";
import ResponsiveCDNImage from "../../../components/common/image/responsive-cdn-image";
import type { Review } from "../../../__generated__/graphql";

interface ReviewDetailModalProps {
  review: Review;
  onClose: () => void;
}

const ReviewDetailModal = ({ review, onClose }: ReviewDetailModalProps) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl w-[90%] max-w-[500px] max-h-[90vh] relative">
      <div className="p-6 overflow-y-auto max-h-[90vh]">
        <div className="flex justify-between items-start gap-2 mb-4">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <span className="text-2xl font-semibold">
                {review.user?.maskedName}
              </span>
              <span className="font-medium text-gray-600">예약구매</span>
            </div>
            <div className="text-gray-500 text-sm">
              {new Date(review.createdAt).toLocaleDateString("ko-KR", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}{" "}
              {new Date(review.createdAt).toLocaleTimeString("ko-KR", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })}
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 active:text-gray-700"
          >
            <HiOutlineXMark className="w-6 h-6" />
          </button>
        </div>

        {review.reviewImages && review.reviewImages.length > 0 && (
          <div className="mb-4">
            <ResponsiveCDNImage
              src={review.reviewImages[0]?.img || ""}
              alt="리뷰 이미지"
              className="w-full h-[300px] object-cover rounded-lg"
            />
          </div>
        )}
        <div className="text-gray-700 whitespace-pre-wrap">{review.content}</div>
      </div>
    </div>
  </div>
);

export default ReviewDetailModal;
